import { SDKDataGridColumn } from "./datagrid-column";
import { SDKDataGridCustomFilter } from "./datagrid-custom-filter";

export class SDKDataGridSettings {
    Name: string = "";
    Columns: SDKDataGridColumn[] = [];
    CustomFilters: SDKDataGridCustomFilter[] = [];
    Active?: boolean = false;
}
